import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { elementsActions } from '../actions/elements.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class ElementsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getElements$ = createEffect(() => {
        return this.actions.pipe(
            ofType(elementsActions.getElements),
            switchMap(({ value }) => {
                return this.httpService.getElements(value).pipe(
                    map((payload) => elementsActions.getElementsSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(elementsActions.getElementsError({ code: error.status }))),
                );
            }),
        );
    });

    getElementsLookup$ = createEffect(() => {
        return this.actions.pipe(
            ofType(elementsActions.getElementsLookup),
            switchMap(() => {
                return this.httpService.getElementsLookup().pipe(
                    map((payload) => elementsActions.getElementsLookupSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(elementsActions.getElementsLookupError({ code: error.status }))),
                );
            }),
        );
    });
}
